// extracted by mini-css-extract-plugin
export default {"root":"SuperAdminMenu_root__siGr8","settingsContainer":"SuperAdminMenu_settingsContainer__H+9s5","tabs":"SuperAdminMenu_tabs__WyoQQ"};